module.exports = __webpack_public_path__ + "img/symbol_2.ac9818c2.png";